import { Loader, Stack } from "@mantine/core";

const Preloader = ({loaderMessage}) => {
  return (
    <div 
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack gap={'lg'} align="center" justify="center">
        <Loader size="4rem" color="rgb(242, 10, 95)" type="dots"/>
        <p style={{fontFamily:'Montserrat, serif,Bebas Neue',fontSize:'18px', textAlign:'center'}}>{loaderMessage}</p>
      </Stack>
    </div>
  );
};
 
export default Preloader;